import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqData = [
  {
    question: "How do I book a cab?",
    answer:
      "You can book a cab by selecting pickup and drop locations, choosing your preferred vehicle type, selecting available cabs, and completing the payment.",
  },
  {
    question: "Can I book a shared cab?",
    answer:
      "Yes, shared cabs are available for all service types — Economy, Standard, and Luxury.",
  },
  {
    question: "Is there a cancellation policy?",
    answer:
      "Yes, you can cancel the ride within 10 minutes of booking for a full refund. After that, a cancellation fee may apply.",
  },
  {
    question: "What payment methods are accepted?",
    answer:
      "We accept UPI, credit/debit cards, net banking, and digital wallets.",
  },
  {
    question: "Can I choose a specific driver or vehicle?",
    answer:
      "At the moment, you can only select a vehicle type. Driver assignment is automatic based on availability.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-12 px-4 md:px-8 font-lato">
      <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">
        Frequently Asked Questions
      </h2>
      <div className="max-w-5xl mx-auto">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className={`bg-white border-b border-blue-200 shadow-sm ${
              index === 0 ? "rounded-t-lg" : ""
            } ${index === faqData.length - 1 ? "rounded-b-lg" : ""}`}
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center px-6 py-4 text-left text-blue-800 font-semibold focus:outline-none"
            >
              <span>{faq.question}</span>
              {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            {openIndex === index && (
              <div className="px-6 pb-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faq;
